import { z } from "zod";
import { rateSchema } from "./common";

// По снимку (`ReportMeta`, `SourceStatus`) обязательны только `generated_at` и `sources`:
// `warnings` и `last_success_at` необязательны, и описывать их обязательными значило ронять разбор
// отчёта на ответе, который сервер считает валидным (P3-11).
const metaSchema = z.object({
  generated_at: z.string(),
  sources: z.array(
    z.object({ system: z.string(), last_success_at: z.string().nullable().optional() }),
  ),
  warnings: z.array(z.string()).optional(),
});

export const onboardingFunnelStepSchema = z.object({
  step_index: z.number().int(),
  template: z.string(),
  viewed: z.number().int(),
  completed_rate: rateSchema,
});

export const onboardingFunnelVariantSchema = z.object({
  variant: z.string(),
  exposed: z.number().int(),
  steps: z.array(onboardingFunnelStepSchema),
  completed: z.number().int(),
  skipped: z.number().int(),
  paywall_viewed: z.number().int(),
  trial: z.number().int(),
  paid: z.number().int(),
});

export const onboardingFunnelResponseSchema = z.object({
  data: z.object({ variants: z.array(onboardingFunnelVariantSchema) }),
  meta: metaSchema,
});
export type OnboardingFunnelResponse = z.infer<typeof onboardingFunnelResponseSchema>;

export const paywallFunnelVariantSchema = z.object({
  variant: z.string(),
  template: z.string(),
  group_parent: z.string().nullable(),
  viewed: z.number().int(),
  plan_selected: z.number().int(),
  cta_tapped: z.number().int(),
  purchase_started: z.number().int(),
  purchase_completed: z.number().int(),
  trial: z.number().int(),
  paid: z.number().int(),
  refund: z.number().int(),
  proceeds_usd: z.number(),
  conversion: rateSchema,
});

export const paywallFunnelResponseSchema = z.object({
  data: z.object({ variants: z.array(paywallFunnelVariantSchema) }),
  meta: metaSchema,
});
export type PaywallFunnelResponse = z.infer<typeof paywallFunnelResponseSchema>;

export const experimentRowSchema = z.object({
  onboarding_variant: z.string(),
  paywall_variant: z.string(),
  revision: z.number().int().nullable().optional(),
  exposed: z.number().int(),
  trial: z.number().int(),
  paid: z.number().int(),
  refund: z.number().int(),
  proceeds_usd: z.number(),
  trial_rate: rateSchema,
  paid_rate: rateSchema,
  significant: z.boolean(),
});
export type ExperimentRow = z.infer<typeof experimentRowSchema>;

export const driftRowSchema = z.object({
  app_version: z.string(),
  surface: z.string(),
  unresolved: z.number().int(),
  total: z.number().int(),
});
export type DriftRow = z.infer<typeof driftRowSchema>;

export const experimentsResponseSchema = z.object({
  data: z.object({
    rows: z.array(experimentRowSchema),
    marginals: z.object({
      onboarding: z.array(experimentRowSchema),
      paywall: z.array(experimentRowSchema),
    }),
    drift: z.array(driftRowSchema),
  }),
  meta: metaSchema,
});
export type ExperimentsResponse = z.infer<typeof experimentsResponseSchema>;
